import {
  DeploymentAlertSetting,
  DeploymentAlertSettingPayload
} from '@/types/deploymentAlert'
import { PaginatedResponse, WithListParams } from '@/types/pagination'
import { vpApi } from './vpApi'

// Scoped to the caller's selected workspace server-side, so no workspace id is sent.
const getDeploymentAlertSettings = async (params: WithListParams) => {
  const res = await vpApi.get<PaginatedResponse<DeploymentAlertSetting[]>>(
    `/v1/deployments/alert-settings/`,
    { params }
  )

  return res.data
}

const createDeploymentAlertSetting = async (
  data: DeploymentAlertSettingPayload
) => {
  const res = await vpApi.post<DeploymentAlertSetting>(
    `/v1/deployments/alert-settings/`,
    data
  )

  return res.data
}

export type UpdateDeploymentAlertSettingParams = {
  id: string
  data: DeploymentAlertSettingPayload
}

const updateDeploymentAlertSetting = async ({
  id,
  data
}: UpdateDeploymentAlertSettingParams) => {
  const res = await vpApi.put<DeploymentAlertSetting>(
    `/v1/deployments/alert-settings/${id}/`,
    data
  )

  return res.data
}

const deleteDeploymentAlertSetting = (id: string) => {
  return vpApi.delete(`/v1/deployments/alert-settings/${id}/`)
}

export const deploymentAlertApi = {
  getDeploymentAlertSettings,
  createDeploymentAlertSetting,
  updateDeploymentAlertSetting,
  deleteDeploymentAlertSetting
}
